import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthServerProvider } from '../services/auth/auth-jwt.service';
import { isBackendRequest } from './backend-request.util';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authServerProvider = inject(AuthServerProvider);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request?.url || !isBackendRequest(request.url)) {
      return next.handle(request);
    }
    const token = this.authServerProvider.getToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token
        }
      });
    }
    return next.handle(request);
  }
}
